export const ResidentAccessOnMyHub = [
  {
    name: "Premium Services",
    isEnabled: true
  },
  {
    name: "Lifestyle Events",
    isEnabled: true
  },
  {
    name: "Community",
    isEnabled: true
  },
  {
    name: "Family",
    isEnabled: true
  },
  {
    name: "Media",
    isEnabled: true
  },
  {
    name: "News",
    isEnabled: true
  },
  {
    name: "Weather Widget",
    isEnabled: true
  },
  {
    name: "Event",
    isEnabled: true
  },
  {
    name: "Maintenance",
    isEnabled: true
  },
  {
    name: "Noticeboard",
    isEnabled: true
  },
  {
    name: "Calendar",
    isEnabled: true
  },
  {
    name: "Take photo",
    isEnabled: true
  },
  {
    name: "Budget",
    isEnabled: true
  },
  {
    name: "Display birthday in MyHub list",
    isEnabled: true
  },
  {
    name: "Voice Assistant",
    isEnabled: true
  },
  {
    name: "Resident Event Pictures",
    isEnabled: true
  },
  {
    name: "Display Resident In Community Directory",
    isEnabled: true
  }
]